export const SUBMIT_API = 'submitapi';
export const NEW_CUST_API = 'newcustapi';
export const EMAIL_AVAILABILITY_CHECK_API = 'emailAvailabilityCheckApi';
export const CONTINUE_API = 'continueapi';
export const APP_PEND_API = 'appPendVerificationApi';
export const APP_PEND_DOCUMENT_UPLOAD_API = 'appPendDocumentUploadApi';
export const APP_PEND_FINAL_SUBMIT_CALL_API = 'appPendFinalSubmitCallToUVSApi';
